import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import SVG from 'components/SVG';
import Modal from 'components/Modal';
import Button from 'components/Button';

import fileSVG from './img/file.svg';
import crossSVG from './img/cross.svg';
import './InstructionButton.scss';

const b = block('instruction-button');

const InstructionButton = () => {
  const locale = useSelector(state => state.locale.locale);
  const role = useSelector(state => state.auth.role);
  const [isOpen, setIsOpen] = useState(false);

  const handleModalClose = () => {
    setIsOpen(ps => !ps);
  }

  if (role !== 1) return null;

  return (
    <div className={b()}>
      <div className={b('base')} onClick={() => setIsOpen(true)}>
        <SVG className={b('icon')} svgProps={{ svg: fileSVG }} />
        {locale.readInstructions}
      </div>

      {isOpen &&
        <Modal onClose={() => {}}>
          <section className={b('modal')}>
            <SVG className={b('modal-cross')} svgProps={{ svg: crossSVG }} onClick={handleModalClose} />
            <h3 className={b('modal-title')}>{locale.instruction}</h3>
            <div className={b('modal-text')}>{locale.instructionText1}</div>
            <div className={b('modal-text')} dangerouslySetInnerHTML={{ __html: locale.instructionText2 }} />
            <div className={b('modal-button')}>
              <Button onClick={handleModalClose}>
                <div className={b('ok')}>{locale.ok}</div>
              </Button>
            </div>
          </section>
        </Modal>}
    </div>
  );
};

export default InstructionButton;
